import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { ExtraView } from '@tokeet-frontend/extras'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import {
  ExtraDialogComponent,
  ExtraDialogTabs,
} from '@tv3/containers/extras/dialogs/extra-dialog/extra-dialog.component'

@Injectable()
export class ExtraDialogService {
  constructor(private dialog: DialogService) {}

  open(data?: {
    extra?: ExtraView
    duplicate?: boolean
    tab?: ExtraDialogTabs
    defaults?: { inquiry_id?: string; rental_id?: string }
  }) {
    const defaultConfig: MatDialogConfig = {
      width: '650px',
      height: 'auto',
      data: { ...data },
    }

    return this.dialog.openVariableDialog(ExtraDialogComponent, defaultConfig)
  }
}
